import { CapabilitiesCheckParams, Capability } from '@hcs/types';
import { logException } from '@hcs/utils';

export const checkHasCapability = (
  capabilityKey: string,
  userCapabilities: Capability[],
) => {
  return userCapabilities.some(
    (capability) => capability.key === capabilityKey,
  );
};

export const checkHasCapabilities = (
  capabilitescheckParams: CapabilitiesCheckParams,
  userCapabilities: Capability[],
) => {
  const { capabilityKeys, operation } = capabilitescheckParams;
  const checks = capabilityKeys.map((capabilityKey) =>
    checkHasCapability(capabilityKey, userCapabilities),
  );
  if (operation === 'AND') {
    return checks.every(Boolean);
  } else if (operation === 'OR') {
    return checks.some(Boolean);
  } else {
    logException(
      'useCapabilitiesCheckForUser called with unknown operation' + operation,
    );
  }
};
